import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import IconAndAmount, { ImgAndAmount } from "../icon-and-amount/IconAndAmount";
import Bath from "@icons-rf/properties-item/bath.svg?react";
import Bed from "@icons-rf/properties-item/bed.svg?react";
import FloorsTotal from "@icons-rf/properties-item/floors-total.svg?react";
import Carro from "@icons-rf/properties-item/carro.svg?react";
import Casa2 from "@icons-rf/properties-item/casa2.svg?react";
import HalfBath from "@icons-rf/properties-item/toiled-grey.png";
import Measure from "@icons-rf/properties-item/medida.svg?react";
import Agua from "@icons-rf/properties-item/agua.svg?react";
import Pump from "@icons-rf/properties-item/pumps.svg?react";
import { styled, Tooltip } from "@mui/material";
import { useWidth } from "@/shared/hooks/use-width.hook";

const PropertyCharacteristics = () => {
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const orderedItems = [
    {
      value: principalData.bedrooms,
      icon: <Bed />,
      tooltip: "Habitaciones"
    },
    {
      value: principalData.bathrooms,
      icon: <Bath />,
      tooltip: "Baños"
    },
    {
      value: principalData.half_bathrooms,
      img: HalfBath,
      tooltip: "Medios baños"
    },
    {
      value: principalData.parking_spots,
      icon: <Carro />,
      tooltip: "Parqueo"
    },
    {
      value: principalData.floor_level,
      icon: <Agua />,
      tooltip: "Nivel de piso"
    },
    {
      value: principalData.floors_total,
      icon: <FloorsTotal />,
      tooltip: "Total de pisos"
    },
    {
      value: principalData.sqm_land,
      icon: <Casa2 />,
      tooltip: "Metros de solar"
    },
    {
      value: principalData.sqm_construction,
      icon: <Measure />,
      tooltip: "Metros de construcción"
    }
  ];

  const extraItems = [
    {
      value: principalData.pumps,
      icon: <Pump />,
      tooltip: "Bombas"
    }
  ];

  const items = [...orderedItems, ...extraItems].filter(item => item.value);

  return (
    <ContainerIconAndAmount>
      {items.map((item, i) => (
        <Tooltip title={item.tooltip} key={i}>
          <div>
            {item?.icon && (
              <IconAndAmount Icon={item.icon} amount={item?.value ?? ""} />
            )}
            {item?.img && <ImgAndAmount img={item.img} amount={item?.value ?? ""} />}
          </div>
        </Tooltip>
      ))}
    </ContainerIconAndAmount>
  );
};

export default PropertyCharacteristics;

const ContainerIconAndAmount = styled("div")(({ theme }) => ({
  marginTop: "20px",
  display: "flex",
  flexWrap: "wrap",
  gap: "30px",
  marginBottom: "20px",

  [theme.breakpoints.down("sm")]: {
    gap: "20px"
  }
}));
